import { useRef, useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import { formatDate } from "../../components/CommonDateFormat";
import CommonSearch2 from "../../components/CommonSearch2";
import { useStatementQueryQuery } from "../../features/api/transactionApi";
function DealerStatement() {
  // useRef for report
  const componentRef = useRef();

  const { data } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = data?.dealer;

  const [tag_ac_id, setDealerId] = useState("");
  const statements = useStatementQueryQuery(
    { legId: 1, tagID: tag_ac_id?.id },
    { refetchOnMountOrArgChange: true }
  )?.data;

  const filterName = dealers?.find((dealer) => dealer?.id == tag_ac_id?.id);

  const totalDabit = statements?.reduce((sum, data) => sum + data?.debit, 0);
  const totalCredit = statements?.reduce((sum, data) => sum + data?.credit, 0);

  let balance = 0;

  return (
    <div className="px-6">
      <div>
        <h1 className="font-bold text-xl my-8">Client Statement</h1>
        <div className="flex items-center gap-8">
          <p className="font-medium">View Account:</p>
          <CommonSearch2
            value={tag_ac_id}
            setValue={setDealerId}
            data={dealers}
          />
        </div>
      </div>
      <div>
        {statements?.length > 0 && (
          <ReactToPrint
            trigger={() => (
              <h1 className="cursor-pointer flex items-center m-1 absolute right-6 ">
                <AiFillPrinter /> print
              </h1>
            )}
            content={() => componentRef.current}
            pageStyle="@page {  margin: 0.5cm; }  }"
          />
        )}
        <div ref={componentRef}>
          {statements?.length === 0 ? (
            <p className="mt-20 ml-20 text-3xl">There are no transaction</p>
          ) : (
            <div className="">
              <div className="flex flex-col  ">
                <div className="flex justify-center my-8 relative">
                  <div className="text-center">
                    <h2 className="font-bold text-xl">
                      Johura Endomed Solution
                    </h2>
                    <p>
                      {" "}
                      15/A Zigatola, Hafizullah Green Tower, Flat # C1,
                      Dhanmondi, Dhaka - 1209
                    </p>
                    <p> 01711-071102, 01977-071102, 01778-874364</p>
                    <p>
                      <span className="">Email:</span> jahangirjohura@gmail.com
                    </p>
                  </div>
                </div>
                <div className=" mb-3 pb-3 border-b border-gray-400 ">
                  <p>Name of Hospital: {filterName?.d_name}</p>
                </div>
                <div>
                  <table className="min-w-full overflow-auto bg-white">
                    <thead>
                      <tr>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Date
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Particulars
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Transaction
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Debit
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Credit
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                          Balance
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {statements?.map((data, index) => {
                        const { debit, credit } = data;
                        balance += debit - credit;
                        return (
                          <tr key={index}>
                            <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {formatDate(data?.trDate)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.description}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.jv_no}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.debit}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {data?.credit}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                              {balance}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <thead>
                      <tr>
                        <th
                          colSpan={3}
                          className="px-6 py-3 border-b-2 font-bold border-gray-300 text-right text-xs uppercase tracking-wider"
                        >
                          Total
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                          {totalDabit}
                        </th>

                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                          {totalCredit}
                        </th>
                        <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider">
                          {/* {totalDabit - totalCredit} */}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className="flex justify-end mt-16">
                  <p className="border-t border-t-black">Signature</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DealerStatement;
